
// DOM-Ready Function
function ready(callback) {
    // in case the document is already rendered
    if (document.readyState != 'loading') callback();
    // modern browsers
    else if (document.addEventListener) document.addEventListener('DOMContentLoaded', callback);
    // IE <= 8
    else document.attachEvent('onreadystatechange', function() {
        if (document.readyState == 'complete') callback();
    });
}

// DOM ready
ready(function() {

    // Matomo
    var _paq = window._paq = window._paq || [];
    _paq.push(["disableCookies"]);
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
        var u="https://matomo.form.taxi/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '2']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
    })();

    // Druck-Befehl
    var objPrint = document.querySelector('a.print-request');
    if (objPrint !== null) {
        objPrint.addEventListener('click', function() {
            window.print();
        });
    }

    // Fehlerklasse bei Feldvalidierung
    var inputElements = document.querySelectorAll('form input, form select, form textarea');
    Array.prototype.forEach.call(inputElements, function(el, i) {

        el.addEventListener('invalid', function(event) {
            event.target.classList.remove('is-success');
            event.target.classList.add('is-error');
        });

        el.addEventListener('blur', function(event) {
            event.target.classList.remove('is-error');
            event.target.classList.add('is-success');
            event.target.checkValidity();
        });
    });
});